import React, { useState, useEffect } from 'react';
import { GetData } from '../utils/api';
import './Terms.css';

const Terms = () => {
  const [terms, setTerms] = useState(null);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const [termsData, settingsData] = await Promise.all([
        GetData('/terms'),
        GetData('/settings')
      ]);
      setTerms(termsData.terms);
      setSettings(settingsData.settings);
    } catch (error) {
      console.error('Error loading terms:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Cargando...</div>;
  }

  const termsContent = terms?.content || [];
  const lastUpdated = terms?.lastUpdated ? new Date(terms.lastUpdated).toLocaleDateString('es', { year: 'numeric', month: 'long', day: 'numeric' }) : new Date().toLocaleDateString('es', { year: 'numeric', month: 'long', day: 'numeric' });
  const contact = settings?.contact || {};

  return (
    <div className="terms-page">
      <div className="container">
        <div className="terms-header">
          <h1>Términos y Condiciones</h1>
          <p className="terms-date">Última actualización: {lastUpdated}</p>
        </div>

        <div className="terms-content">
          <div className="terms-notice">
            <p>
              <strong>Nota importante:</strong> Este es un sitio de demostración.
              Los siguientes términos y condiciones son ejemplos con fines educativos.
            </p>
          </div>

          {termsContent.length > 0 ? termsContent.map((section, index) => (
            <section key={index} className="terms-section">
              <h2>{index + 1}. {section.title}</h2>
              <p>{section.text}</p>
            </section>
          )) : (
            <section className="terms-section">
              <h2>1. Aceptación de los Términos</h2>
              <p>
                Al acceder y utilizar este sitio web, usted acepta estar sujeto a estos términos y
                condiciones de uso, todas las leyes y regulaciones aplicables.
              </p>
            </section>
          )}

          {termsContent.length > 0 && (
            <section className="terms-section">
              <h2>Contacto</h2>
              <p>
                Si tiene alguna pregunta sobre estos Términos y Condiciones, puede contactarnos:
              </p>
              <ul>
                {contact.email && <li>Por email: <a href={`mailto:${contact.email}`}>{contact.email}</a></li>}
                {contact.phone && <li>Por teléfono: {contact.phone}</li>}
                <li>A través de nuestra <a href="/contact">página de contacto</a></li>
              </ul>
            </section>
          )}
        </div>
      </div>
    </div>
  );
};

export default Terms;
